<div class="notebook-secret-modal">
  <div class="secret-modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mode-dialog-header>
      <h1 heading>New secret</h1>
    </mode-dialog-header>
  </div>
  <div class="content-container">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <p class="description">
        Add a secret to reference sensitive values like API tokens or passwords within Python cells in this Notebook.
        Once saved, the value will be hidden.
      </p>
      <div class="form-input">
        <label for="secretKey">Display name</label>
        <input
          id="secretKey"
          type="text"
          formControlName="secretKey"
          data-test="secretKey"
          #secretKeyInput
          [ngClass]="{ error: secretKey?.invalid && (secretKey?.dirty || secretKey?.touched) }"
          autocomplete="off"
        />
        <div class="text-error" *ngIf="secretKey?.invalid && (secretKey?.dirty || secretKey?.touched)">
          <div *ngIf="secretKey.errors.required">Name can’t be blank</div>
          <div *ngIf="secretKey.errors.maxlength">Name can’t be more than 100 characters long</div>
          <div *ngIf="secretKey.errors.pattern">
            Name can only contain alpha-numeric characters & underscores, and begin with a letter.
          </div>
          <div *ngIf="secretKey.hasError('invalidSecretKey')">
            This name is already taken by a secret in this Report
          </div>
        </div>
      </div>
      <div class="form-input">
        <label for="secretValue">Secret value</label>
        <input
          id="secretValue"
          [type]="showPassword ? 'text' : 'password'"
          data-test="secretValue"
          formControlName="secretValue"
          [ngClass]="{ error: secretValue?.invalid && (secretValue?.dirty || secretValue?.touched) }"
          autocomplete="off"
        />
        <div class="text-error" *ngIf="secretValue?.invalid && (secretValue?.dirty || secretValue?.touched)">
          <div *ngIf="secretValue.errors.required">Secret value can’t be blank</div>
          <div *ngIf="secretValue.errors.maxlength">Secret value can’t be more than 4096 characters long</div>
        </div>
      </div>
      <div class="form-input checkbox">
        <span class="checkbox-icon">
          <input
            id="showValue"
            data-test="showValue"
            type="checkbox"
            (change)="togglePasswordVisibility()"
            formControlName="showValue"
            class="checkbox"
          />
          <label for="showValue" class="inline-icon icon-editor-checkbox-light-unchecked">Show value</label>
        </span>
      </div>
      <div class="action-buttons">
        <div class="right-actions">
          <capra-button
            type="button"
            data-test="secret-modal-cancel-button"
            text="Cancel"
            variant="secondary"
            color="neutral"
            (clicked)="close()"
          ></capra-button>
          <capra-button
            type="button"
            data-test="secret-modal-create-button"
            text="Save"
            color="default"
            [disabled]="!form.valid"
            (clicked)="onSubmit()"
          ></capra-button>
        </div>
      </div>
    </form>
  </div>
</div>
